import { SovosButton, SovosCircularProgress } from "mosaic-react";
import { AutoAwesome } from "mosaic-react-icons";
import React from "react";

const MapByAiButton = ({ disabled, i18n, loading, onClick }) => (
    <SovosButton
        disabled={disabled || loading}
        onClick={onClick}
        size="small"
        startIcon={
            loading ? <SovosCircularProgress aria-label={i18n`Loading AI suggestions`} size="0.875rem" /> : <AutoAwesome />
        }
        variant="text"
    >
        {i18n`Map by AI`}
    </SovosButton>
);

export default MapByAiButton;
